export default __webpack_public_path__ + "static/media/errorMB@2x.2a451648.png";